import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import * as S from './styles';

// Componentes
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import HomeCabecario from '../../components/HomeCabecario';

// Serviços e Ícones
import HiperlinkService from '../../services/hiperlink/hiperlink.js';
import { MdArrowBack, MdEdit, MdDelete } from 'react-icons/md';

function Hiperlink() {
    const navigate = useNavigate();
    
    // Estados do componente
    const [hiperlinks, setHiperlinks] = useState([]);
    const [currentHiperlink, setCurrentHiperlink] = useState({ descricao: '', link: '', texto: '', tipo: 'web' });
    const [isEditing, setIsEditing] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    // Função para buscar os hiperlinks da API
    const fetchHiperlinks = async () => {
        setIsLoading(true);
        try {
            const data = await HiperlinkService.getHiperlinks();
            setHiperlinks(data);
            setError(null);
        } catch (err) {
            console.error(err);
            // Verifica se o erro é pela falta do ID da rede para dar uma mensagem mais clara
            if (err.message && err.message.includes("ID da rede não encontrado")) {
                setError("Nenhuma rede selecionada. Por favor, vá para a tela de administração e selecione uma rede para continuar.");
            } else {
                setError('Falha ao carregar os hiperlinks. Tente novamente.');
            }
        } finally {
            setIsLoading(false);
        }
    };

    // useEffect para carregar os dados quando o componente montar
    useEffect(() => {
        fetchHiperlinks();
    }, []);

    // Manipulador para mudanças nos inputs do formulário
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setCurrentHiperlink({ ...currentHiperlink, [name]: value });
    };

    // Manipulador para submeter o formulário (criar ou atualizar)
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!currentHiperlink.descricao || !currentHiperlink.link || !currentHiperlink.texto) {
            alert('Por favor, preencha a descrição, o link e o texto do hiperlink.');
            return;
        }

        try {
            if (isEditing) {
                await HiperlinkService.updateHiperlink(currentHiperlink);
                alert('Hiperlink atualizado com sucesso!');
            } else {
                await HiperlinkService.createHiperlink(currentHiperlink);
                alert('Hiperlink criado com sucesso!');
            }
            resetForm();
            fetchHiperlinks(); // Recarrega a lista
        } catch (err) {
            alert(`Erro ao salvar o hiperlink: ${err.message}`);
        }
    };

    // Função para preparar o formulário para edição
    const handleEdit = (hiperlink) => {
        setIsEditing(true);
        setCurrentHiperlink(hiperlink);
        window.scrollTo(0, 0); // Rola a página para o topo para ver o formulário
    };

    // Função para deletar um hiperlink
    const handleDelete = async (id) => {
        if (window.confirm('Tem certeza que deseja deletar este hiperlink?')) {
            try {
                await HiperlinkService.deleteHiperlink(id);
                alert('Hiperlink deletado com sucesso!');
                fetchHiperlinks(); // Recarrega a lista
            } catch (err) {
                alert(`Erro ao deletar o hiperlink: ${err.message}`);
            }
        }
    };

    // Função para limpar o formulário e sair do modo de edição
    const resetForm = () => {
        setIsEditing(false);
    };

    const handleBack = () => {
        navigate('/marketdo');
    };

    return (
        <S.Container>
            <Header />
           
            <S.BackButton onClick={handleBack}>
                <MdArrowBack style={{ marginRight: '8px', fontSize: '20px' }} />
                Voltar
            </S.BackButton>

            <S.Form onSubmit={handleSubmit}>
                <S.Title>{isEditing ? 'Editar Hiperlink' : 'Novo Hiperlink'}</S.Title>
                <S.InputGroup>
                    <S.Label htmlFor="descricao">Descrição</S.Label>
                    <S.Input id="descricao" name="descricao" value={currentHiperlink.descricao} onChange={handleInputChange} placeholder="Ex: MarketDo Site" required />
                </S.InputGroup>
                <S.InputGroup>
                    <S.Label htmlFor="texto">Texto</S.Label>
                    <S.Input id="texto" name="texto" value={currentHiperlink.texto} onChange={handleInputChange} placeholder="Ex: Acesse o MarketDo" required />
                </S.InputGroup>
                <S.InputGroup>
                    <S.Label htmlFor="link">URL do Link</S.Label>
                    <S.Input id="link" name="link" type="url" value={currentHiperlink.link} onChange={handleInputChange} placeholder="https://exemplo.com.br" required />
                </S.InputGroup>
                <S.InputGroup>
                    <S.Label htmlFor="tipo">Tipo</S.Label>
                    <S.Select id="tipo" name="tipo" value={currentHiperlink.tipo} onChange={handleInputChange}>
                        <option value="web">Web</option>
                         <option value="web-campanha">web-campanha</option>
                        <option value="app">App</option>
                    </S.Select>
                </S.InputGroup>
                <S.ButtonGroup>
                    {isEditing && (
                        <S.Button type="button" className="cancel" onClick={resetForm}>
                            Cancelar
                        </S.Button>
                    )}
                    <S.Button type="submit">{isEditing ? 'Salvar Alterações' : 'Cadastrar'}</S.Button>
                </S.ButtonGroup>
            </S.Form>

            {isLoading ? (
                <p>Carregando...</p>
            ) : error ? (
                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                    <p style={{ color: 'red' }}>{error}</p>
                    {/* Se o erro for sobre a rede, mostra um botão para corrigir */}
                    {error.includes("Nenhuma rede selecionada") && (
                        <S.Button onClick={() => navigate('/marketdo')} style={{ marginTop: '10px' }}>
                            Ir para Administração
                        </S.Button>
                    )}
                </div>
            ) : (
                <S.StyledTable>
                    <thead>
                        <tr>
                            <th>Descrição</th>
                            <th>Texto</th>
                            <th>Link</th>
                            <th>Tipo</th>
                            <th>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {hiperlinks.map((hiperlink) => (
                            <tr key={hiperlink._id}>
                                <td>{hiperlink.descricao}</td>
                                <td>{hiperlink.texto}</td>
                                <td><a href={hiperlink.link} target="_blank" rel="noopener noreferrer">{hiperlink.link}</a></td>
                                <td>{hiperlink.tipo}</td>
                                <td>
                                    <S.ActionButton type="edit" onClick={() => handleEdit(hiperlink)}>
                                        <MdEdit />
                                    </S.ActionButton>
                                    <S.ActionButton type="delete" onClick={() => handleDelete(hiperlink._id)}>
                                        <MdDelete />
                                    </S.ActionButton>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </S.StyledTable>
            )}

            <Footer />
        </S.Container>
    );
}

export default Hiperlink;
